import React from "react";

export interface ExamCandidateCaseName {
  candidateId: string;
  examId: string;
  caseName?: string;
}

export interface SchedulerCaseNameContext {
  examCandidateCaseNames: ExamCandidateCaseName[];
  updateCaseName: (candidateId: string, examId: string, caseName: string) => void;
}

export const initialSchedulerCaseNameContextValue: SchedulerCaseNameContext = {
  examCandidateCaseNames: [],
  updateCaseName: (candidateId: string, examId: string, caseName: string) => {},
};

export const SchedulerCaseNameContextValue = React.createContext<SchedulerCaseNameContext>(
  initialSchedulerCaseNameContextValue
);
